var map = {
	"./room1-0.jpg": 3325,
	"./room1-1.jpg": 1039,
	"./room1-2.jpg": 8224,
	"./room1-3.jpg": 4877,
	"./room2-0.jpg": 4542,
	"./room2-2.jpg": 3379,
	"./room2-3.jpg": 8230,
	"./room2-win.jpg": 2328
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1148;